import { IntegrationSettingsPendingApproval } from './../services/integration.service';

const INITIAL_STATE: IntegrationState = {
  shopIntegrationId: null,
  integrationTypeId: null,
  integrationConfirmation: null,
  itsAlreadySubmitted: false,
  hash: null,
};

const NAMESPACE = 'INTEGRATIONS';

export const IntegrationActions = {
  INIT: `${NAMESPACE}.INIT`,
  SET_INTEGRATION_ID: `${NAMESPACE}.SET_INTEGRATION_ID`,
  SET_INTEGRATION: `${NAMESPACE}.SET_INTEGRATION`,
  SET_INTEGRATION_CONFIRMATION: `${NAMESPACE}.SET_INTEGRATION_CONFIRMATION`,
  SET_IS_ALREADY_SUBMITTED: `${NAMESPACE}.SET_IS_ALREADY_SUBMITTED`,
  SET_HASH: `${NAMESPACE}.SET_HASH`,
};

export function IntegrationReducer(state: IntegrationState = INITIAL_STATE, action: any) {
  const temp = {...state};
  switch (action.type) {
    case IntegrationActions.INIT:
      return {...INITIAL_STATE};
    case IntegrationActions.SET_INTEGRATION_ID:
      temp.shopIntegrationId = action.payload;
      return temp;
    case IntegrationActions.SET_INTEGRATION:
      temp.shopIntegrationId = action.payload.shopIntegrationId;
      temp.integrationTypeId = action.payload.integrationTypeId;
      return temp;
    case IntegrationActions.SET_INTEGRATION_CONFIRMATION:
      temp.integrationConfirmation = action.payload;
      temp.itsAlreadySubmitted = false;
      return temp;
    case IntegrationActions.SET_IS_ALREADY_SUBMITTED:
      temp.itsAlreadySubmitted = true;
      return temp;
    case IntegrationActions.SET_HASH:
      temp.hash = action.payload;
      return temp;
    default:
      return temp;
  }
}

export interface IntegrationState {
  shopIntegrationId?: number;
  integrationTypeId?: number;
  integrationConfirmation?: IntegrationSettingsPendingApproval;
  itsAlreadySubmitted?: boolean;
  hash: string;
}
